import axios from "axios"

const API_BASE = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "")

const api = axios.create({
  baseURL: `${API_BASE}/api/v1/`,
})

api.interceptors.request.use(config => {
  const userInfo = sessionStorage.getItem("user-info")
  if (userInfo) {
    try {
      const parsed = JSON.parse(userInfo)
      if (parsed.token) {
        config.headers.Authorization = `Bearer ${parsed.token}`
      }
    } catch {}
  }
  return config
})

export const emailApi = {
  // ── SMTP Accounts (existing system) ──
  getSmtpAccounts: (params = {}) => api.get("smtp-accounts/", { params }),

  // ── Candidates (for To field) ──
  searchCandidates: (query = "") =>
    api.get("candidates/", {
      params: { search: query, page_size: 20 },
    }),

  // ── Send Email via existing Celery pipeline ──
  sendEmail: payload => api.post("emails/", payload),

  // ── General mailbox send: to anyone, with Cc/Bcc + file attachments ──
  // Pass a FormData (account_id, to_addresses[], cc_addresses[], bcc_addresses[],
  // subject, body_html, body_text, attachments files).
  sendMailboxEmail: formData =>
    api.post("email/send/", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  // ── Email Module API (folders, messages, drafts, etc.) ──
  getAccounts: () => api.get("email/accounts/"),
  createAccount: data => api.post("email/accounts/", data),
  updateAccount: (id, data) => api.patch(`email/accounts/${id}/`, data),
  autoSetupAccount: () => api.post("email/accounts/auto_setup/"),
  disconnectAccount: id => api.post(`email/accounts/${id}/disconnect/`),
  getFolders: accountId =>
    api.get("email/folders/", { params: { account: accountId } }),
  createFolder: data => api.post("email/folders/", data),
  updateFolder: (id, data) => api.patch(`email/folders/${id}/`, data),
  deleteFolder: id => api.delete(`email/folders/${id}/`),
  markAllFolderRead: id => api.post(`email/folders/${id}/mark_all_read/`),
  cleanUpFolder: id => api.post(`email/folders/${id}/clean_up/`),
  deleteAllFolder: id => api.post(`email/folders/${id}/delete_all/`),
  getFolderProperties: id => api.get(`email/folders/${id}/properties/`),
  reorderFolders: data => api.post("email/folders/reorder/", data),
  getLabels: accountId =>
    api.get("email/labels/", { params: { account: accountId } }),
  createLabel: data => api.post("email/labels/", data),
  getMessages: (params = {}) => api.get("email/messages/", { params }),
  getMessage: id => api.get(`email/messages/${id}/`),
  toggleRead: id => api.post(`email/messages/${id}/toggle_read/`),
  toggleStar: id => api.post(`email/messages/${id}/toggle_star/`),
  toggleFlag: id => api.post(`email/messages/${id}/toggle_flag/`),
  togglePin: id => api.post(`email/messages/${id}/toggle_pin/`),
  moveMessage: (id, folderId) =>
    api.post(`email/messages/${id}/move/`, { folder_id: folderId }),
  addLabel: (id, labelId) =>
    api.post(`email/messages/${id}/add_label/`, { label_id: labelId }),
  removeLabel: (id, labelId) =>
    api.post(`email/messages/${id}/remove_label/`, { label_id: labelId }),
  bulkAction: data => api.post("email/messages/bulk_action/", data),
  searchMessages: params => api.get("email/messages/search/", { params }),
  getStats: accountId =>
    api.get("email/messages/stats/", { params: { account: accountId } }),
  getThreads: (params = {}) => api.get("email/threads/", { params }),
  getDrafts: () => api.get("email/drafts/"),
  saveDraft: data => api.post("email/drafts/save_draft/", data),
  syncEmails: data => api.post("email/sync/sync/", data),
  syncAllEmails: data => api.post("email/sync/sync_all/", data),
  syncFolder: data => api.post("email/sync/sync_folder/", data),
  getCalendarEvents: (params = {}) =>
    api.get("email/sync/calendar/", { params }),
  getAddressBookContacts: (params = {}) =>
    api.get("email/sync/contacts/", { params }),

  // ── Resume attachment → Job order / Candidates database ──
  getJobOrders: (params = {}) => api.get("create-job-order/", { params }),
  attachmentToJob: data => api.post("email/attachments/add_to_job/", data),
  attachmentToDatabase: data =>
    api.post("email/attachments/add_to_database/", data),
}

export default emailApi
